<script>
  import Events from 'src/pc/pages/Events'
  import PageLayout from '../layouts/PageLayout'
	import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: Events,
    components: {
      PageLayout,
      DisplayContainer,
    },
    computed: {
      getAccess () {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .live_events {
    top: 0 !important;
  }
  .live_events .display-container.title {
    width: 100vw;
    margin-bottom: 30px;
  }
  .live_events .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .live_events .title_top:before {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .live_events .title_top p {
    font-size: 34px;
  }
  .live_events .container {
    display: block;
    width: 100vw;
    margin-left: -20px;
  }
  .live_events .events {
    margin-bottom: 40px;
  }
  .live_events .events h3 {
    font-size: 20px;
    line-height: 1.0em;
    margin-bottom: 15px;
    letter-spacing: -0.01em;
  }
  .live_events .events .event_ctnr {
    margin-bottom: 12px;
  }
  .live_events .events .event_ctnr p {
    position: relative;
    width: 100%;
    height: 110px;
  }
  .live_events .events .event_ctnr p img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .live_events .events .event_ctnr p:hover img {
    filter: brightness(100%);
  }

  .live_events .events .event_ctnr .reports {
    padding: 5px 12px 0;
  }
  .live_events .events .event_ctnr .reports:last-child {
    padding-bottom: 12px;
  }
  .live_events .events .event_ctnr .report_ctnr {
    padding: 12px 38px 12px 82px;
    font-size: 13px;
    line-height: 1.4em;
  }
  .live_events .events .event_ctnr .report_ctnr:after {
    width: 10px;
    height: 10px;
    top: 50%;
    right: 15px;
    transform: translate(0, -50%) rotate(-90deg);
  }
  .live_events .events .event_ctnr .report_ctnr .img {
    width: 36px;
    top: 0;
    left: 20px;
    transform: translate(0, 0);
  }
  .live_events .events .event_ctnr .report_ctnr .img:after {
    top: -12px;
    left: -2px;
  }
  .live_events .events .event_ctnr .report_ctnr i {
    font-weight: 800;
    display: inline-block;
  }
  .live_events .events .event_ctnr .report_ctnr em {
    font-size: 11px;
    width: 60px;
    padding: 4px;
    left: 12px;
  }
  .live_events .events .event_ctnr .report_ctnr em:before {
    width: 20px;
    height: 20px;
  }
  .live_events .events .event_ctnr p:hover a .btn {
    opacity: 0;
  }
  .live_events .events .event_ctnr p a:after {
    content: "…";
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: rgba(0,0,0,0.35);
    /*border: 1px solid rgba(255,255,255,0.25);*/
    border-radius: 5.0em;
    font-size: 24px;
    font-weight: 500;
    color: #fff;
    position: absolute;
    top: 8px;
    right: 8px;
    transform: rotate(0deg);
  }
  .live_events .events .event_ctnr.past .report_ctnr em {
    font-size: 9px;
  }
</style>
